var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLselectricLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 30,
    viewBox: "0 0 192 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8338 3.29456H38.8342C30.6876 3.29456 27.0097 8.64339 27.0097 12.4418C27.0097 16.2403 30.1339 19.186 38.241 19.186H39.902C41.6816 19.186 42.6703 19.4186 42.7098 20.6201C42.7098 21.2791 42.2748 22.0155 41.8003 22.3643C40.6929 23.1783 39.7438 23.2946 34.6423 23.2946H9.33228L14.2361 3.33332H5.77307C5.21941 3.33332 4.98213 3.48835 4.82394 4.14727L0.196957 22.8682C-0.673074 26.5891 1.30427 30 5.65442 30H17.2417C20.1681 30 24.1228 26.8604 25.7047 23.9535C25.7838 23.7984 25.8629 23.6822 25.9024 23.5659C25.9024 23.5659 25.942 23.5271 25.942 23.5659C25.7047 24.6124 24.8347 28.2946 24.6765 28.9147C24.4787 29.6899 24.9137 30 25.3092 30H37.7665C48.3255 30 52.4779 25.0775 52.8338 19.1473C53.0316 15.8139 50.896 13.6822 44.8058 13.6822H40.1393C38.4783 13.6822 36.7778 13.1395 36.7778 11.8217C36.7778 10.5039 38.6365 9.34107 41.128 9.34107H52.4779C52.4779 9.34107 53.4666 5.42634 53.6643 4.61238C53.9411 3.60463 53.6248 3.29456 52.8338 3.29456Z",
    fill: "#003378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3932 5.85271L67.9804 0H45.3992C45.3992 0 55.1672 1.93798 56.0373 2.13178C56.9073 2.28682 57.105 2.75194 56.9468 3.37209C56.8282 3.91473 56.3932 5.85271 56.3932 5.85271Z",
    fill: "#E6003E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 19.7675L112.945 18.1008C113.182 17.1706 112.589 16.7054 111.956 16.7054H98.5896C97.8382 16.7054 97.68 16.8992 97.5218 17.5194L95.2281 26.938L94.8722 28.4109C94.6349 29.2636 94.8327 30 95.94 30H108.951C109.979 30 110.454 29.3411 110.691 28.6047L111.086 26.938H98.9455L99.4992 24.7675H108.002C109.03 24.7675 109.505 24.1085 109.742 23.3721L110.137 21.7054H100.251L100.725 19.7675H112.55Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3925 16.7054H81.5056C80.7542 16.7054 80.596 16.8992 80.4378 17.5194L77.7487 28.4109C77.5114 29.2636 77.7091 30 78.8164 30H91.7482C92.7765 30 93.251 29.3411 93.4883 28.6047L93.8838 26.938H81.9011L84.3925 16.7054Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.971 16.7054H181.915C178.276 16.7054 176.26 18.1008 175.39 21.4341L174.599 24.6512C173.966 27.4806 174.717 29.9613 178.711 29.9613H188.084C189.112 29.9613 189.587 29.3023 189.824 28.5659L190.22 26.8992H180.096C178.356 26.8992 178 26.0465 178.276 24.8062L178.949 22.0543C179.384 20.3101 180.926 19.7287 182.231 19.7287H191.564L191.96 18.062C192.197 17.1706 191.564 16.7054 190.971 16.7054Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.198 16.7054H120.142C116.504 16.7054 114.487 18.1008 113.617 21.4341L112.826 24.6512C112.193 27.4806 112.945 29.9613 116.939 29.9613H126.312C127.34 29.9613 127.814 29.3023 128.052 28.5659L128.447 26.8992H118.323C116.583 26.8992 116.227 26.0465 116.504 24.8062L117.176 22.0543C117.611 20.3101 119.154 19.7287 120.459 19.7287H129.792L130.187 18.062C130.464 17.1706 129.831 16.7054 129.198 16.7054Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.057 16.7054H170.249L167.362 28.4109C167.125 29.2636 167.323 30 168.43 30H171.119L174.046 18.1008C174.322 17.1706 173.69 16.7054 173.057 16.7054Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.21 18.1008C149.448 17.1706 148.854 16.7054 148.222 16.7054H132.719C131.968 16.7054 131.81 16.8992 131.651 17.5194L131.098 19.7675H137.939L135.804 28.4109C135.567 29.2636 135.764 30 136.872 30H139.363L141.855 19.7675H148.775L149.21 18.1008Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.458 16.7054H151.701C150.95 16.7054 150.792 16.8992 150.633 17.5194L147.944 28.4109C147.707 29.2636 147.905 30 149.012 30H151.306L153.837 19.7675H161.746C164.356 19.7675 163.763 23.2946 160.718 23.2946H155.023C154.469 23.2946 154.232 23.876 154.628 24.2636L156.565 26.3566L158.978 28.9535C159.729 29.8062 159.927 30 161.034 30H164.831L161.271 26.3566C168.271 25.8527 169.853 16.7054 162.458 16.7054Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1446 13.2559H61.258C60.3485 13.2559 60.1112 13.4884 59.9135 14.2636L56.987 26.1241L56.5124 27.9845C56.2356 29.031 56.4729 29.9613 57.857 29.9613H74.269C75.574 29.9613 76.1672 29.1473 76.4441 28.1783L76.8395 26.5504H61.0603L61.8513 23.3334H73.043C74.3481 23.3334 74.9413 22.5194 75.2181 21.5504L75.7322 19.4574H62.7608L63.4727 16.5504H78.896L79.2914 14.9225C79.6869 13.8373 78.9355 13.2559 78.1446 13.2559Z",
    fill: "url(#paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 103.767,
    y1: 29.702,
    x2: 103.767,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 85.7527,
    y1: 29.702,
    x2: 85.7527,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 183.023,
    y1: 29.702,
    x2: 183.023,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 121.287,
    y1: 29.702,
    x2: 121.287,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 170.573,
    y1: 29.702,
    x2: 170.573,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 139.948,
    y1: 29.702,
    x2: 139.948,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 157.489,
    y1: 29.702,
    x2: 157.489,
    y2: 16.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 67.9399,
    y1: 29.7038,
    x2: 67.9399,
    y2: 16.3717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 30,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLselectricLogo);
export default __webpack_public_path__ + "static/media/lselectric_logo.5e949c2243f7f07a4f95828271b7277f.svg";
export { ForwardRef as ReactComponent };